export default __webpack_public_path__ + "static/media/h24koritu.da806c86.mp3";